import React, { useState } from 'react';
import { toast } from '@dashboard/context/ToastContext';
import { apiUrl } from '@/dashboard/services/env';

const BullBoard = () => {
  const [iframeLoaded, setIframeLoaded] = useState(false);
  const [error, setError] = useState(null);

  const bullBoardUrl = `${apiUrl.replace('/api/v1', '')}/admin/login`;

  const handleIframeLoad = () => {
    setIframeLoaded(true);
  };

  const handleIframeError = () => {
    setError('Failed to load Bull Board. Please check your permissions.');
    toast({
      title: 'Failed to load queue dashboard',
      description: 'Please check your permissions and try again.',
      type: 'error',
    });
  };

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[400px] space-y-4">
        <div className="text-red-600 dark:text-red-400 text-lg font-medium">
          Unable to load Bull Board
        </div>
        <div className="text-gray-600 dark:text-muted-foreground text-sm">{error}</div>
        <button
          onClick={() => window.location.reload()}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="h-full">
      <div className="mb-4">
        <h1 className="text-lg font-bold text-gray-900 dark:text-foreground">Queue Management</h1>
        <p className="mt-1 text-sm text-gray-600 dark:text-muted-foreground">
          Monitor and manage background job queues with Bull Board.
        </p>
      </div>

      <div className="relative bg-white dark:bg-background shadow-sm rounded-lg border border-gray-200 dark:border-border overflow-hidden">
        <iframe
          src={bullBoardUrl}
          width="100%"
          height="800px"
          frameBorder="0"
          title="Bull Board - Queue Management Dashboard"
          onLoad={handleIframeLoad}
          onError={handleIframeError}
          className={`w-full transition-opacity duration-300 ${
            iframeLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          style={{ minHeight: '800px' }}
          sandbox="allow-same-origin allow-scripts allow-forms allow-popups"
        />
      </div>

      <div className="mt-4 text-xs text-gray-500 dark:text-muted-foreground">
        * This dashboard is powered by{' '}
        <a
          href="https://github.com/felixmosh/bull-board"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-400 underline"
        >
          Bull Board
        </a>
      </div>
    </div>
  );
};

export default BullBoard;
